import { render } from "./Resultado.vue?vue&type=template&id=47e5994f"
import script from "./Resultado.vue?vue&type=script&lang=js"
export * from "./Resultado.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__